import React, { useState, forwardRef, useEffect,useImperativeHandle  } from 'react';
import {Modal} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import axios from "axios";
 import {useNavigate, useParams} from "react-router-dom";

const InviteCustomer = forwardRef((props, ref) => {
   const navigate = useNavigate();
      const [inviteModal , setInviteModal] = useState(false);
      const [data , setData] = useState([]);
      const [dataemp , setdataemp] = useState([]);
      const [tecsalary , settecsalary] = useState('');

    useImperativeHandle(ref, () => ({
        showInviteModal() {
            setInviteModal(true)
        }
    
      }))      ;
      
     
      const userdata1 = localStorage.getItem('USER_data');
      const userData = JSON.parse(userdata1);
        const userid = userData.id;  

    const [hallData, setHallData] = useState({
        ReceiptExpenseID : '',
 	Description : 'مصاريف الموظف',
	Amount : '',
	ExpenseDate : '',
	ExpenseTypeID : '',
	reference_number: '',
 	TechnicianID 	: '',
  PurchaseOrderID : '',
  UserID: userid,
  status:'',
  PaymentMethod:'cash',
    });
     useEffect(() => {
        if (userid) {
          setHallData((prevData) => ({
            ...prevData,
            UserID: userid,
          }));
        }
      }, [userid]);
    useEffect(() => {
      getexpensis();
      fetchProducts()
             }, [])
             const fetchProducts = async () => {
                await axios.get('https://subk.education.com.ly/back/api/getEmp1').then(({ data }) => {setdataemp(data)}) 
              }
    const getexpensis = () => {
      axios.get('https://subk.education.com.ly/back/api/getempexpensestype')
       .then(({ data }) => {
          setData(data.ExpenseType)
       })
       .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
       
       }
       const [errors, setErrors] = useState('')

console.log('data',hallData)
const handleInputChange1 = (e) => {
  setErrors('')
  const { name, value } = e.target;

     if (/^\d*$/.test(value)) {
      setHallData((prevData) => ({
        ...prevData,
        [name]: value,
      }));

    }else {
      setErrors("هده الخانه لاتقبل الا الاعداد الصحيحة")

  
  
  }

};
   const handleInputChange = (e) => {
    const { name, value } = e.target;
    // dataemp.map((item) => {
//         if (value == item.TechnicianID) {
          
// settecsalary(item.SalaryAmount)
//         }else{
//           settecsalary("هدا الموظف براتب نسبي")

//         }
  
//       })
    setHallData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === 'ExpenseTypeID' && value == 7) 
      {
      setHallData((prevData) => ({
        ...prevData,
        status: 'دين',
      }));
    }
  };

  const handleSubmit = async(e)=>{
    e.preventDefault();
    await axios.post('https://subk.education.com.ly/back/api/receiptexpenses', hallData)
     // setNotification('User was successfully created')
     // navigate('/users')
     .catch(function (error) {
        if (error.response) {
           console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
     
      setInviteModal(false);
      props.parentFunction()
      setHallData('')
   
      ;  };
      const showInviteModal = () => {   
        
        setInviteModal(false)

    }
     

    return(
        <>
            <Modal className="modal fade" id="exampleModal1" show={inviteModal}  centered>                
                <div className="modal-content">
                <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">إضافة مصروفات الموظف</h1>
                        <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>setInviteModal(false)}></button>
                    </div>
                          <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xl-12">
                      

                            <div className="row">
                            <div className="col-xl-6">
                                        <label className="form-label ">اختر الموظف<span className="text-danger">*</span></label>
                                        <select required className="default-select form-control" name="TechnicianID" defaultValue={hallData.TechnicianID} onChange={handleInputChange}>
                                 <option  data-display="Select">اختر من القائمة</option>
                                 {
                                   dataemp.map((row)=>(
                                
                                 <option key={row.TechnicianID} value={row.TechnicianID}>
                                            {row.FirstName}
                                    </option>
                                     ))}
                                 </select>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="form-label ">تاريخ الصرف<span className="text-danger">*</span></label>
                                        <div className="input-group">
                                            <input  required type="date"className="form-control" name="ExpenseDate" defaultValuevalue={hallData.ExpenseDate} onChange={handleInputChange} />

                                        </div>
                                    </div>
                                    <div className="col-xl-6">
                                        <label className="form-label ">القيمة<span className="text-danger">*</span></label>

                                        
                                        <div className="input-group">
 
                                        <input required type="text" className="form-control" name="Amount" defaultValuevalue={hallData.Amount} onChange={handleInputChange1} />

                                         </div>
                                         {errors ? <div className=' alert alert-danger'>{errors}</div> : ""}

                                    </div>
                                                         
                                </div>
                                <div className="col-xl-12">
                                <label className="form-label mt-3">دالك لــ<span className="text-danger">*</span></label>
                             
                                <select className="default-select form-control" name="ExpenseTypeID" defaultValuevalue={hallData.ExpenseTypeID} onChange={handleInputChange}>
                                 <option required  data-display="Select">اختر من القائمة</option>
                                 {
                                   data.map((row)=>(
                                
                                 <option key={row.ExpenseTypeID} value={row.ExpenseTypeID}>
                                            {row.TypeName}
                                    </option>
                                     ))}
                                 </select>   </div>


                               
                            </div>
                        </div>                                
                    </div>
                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary" >
                       
                        حفظ</button>
                        <button type="button" className="btn btn-danger light" onClick={()=>showInviteModal()}>إلغاء</button>

                    </div> 
                     </form>
                </div>               
            </Modal>
        </>
    )
})
export default InviteCustomer;

